const myEnvironmentRoutes = {
  LOGIN: '/',
  RESERVATIONS: '/reservations',
  RESERVATION: '/reservations/:travelplanId',
} as const;

export default myEnvironmentRoutes;
